<template>
  <v-container fluid fill-height>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card class="elevation-12">
          <v-toolbar color="warning" flat>
            <v-toolbar-title class="white--text">{{
              messageTitle
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <div class="subtitle-2">{{ messageText }}</div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="mb-3"
              @click="closeAlert"
              color="warning"
              width="100"
              large
              >OK</v-btn
            >
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      messageTitle: "SESSION EXPIRED",
      messageText:
        "Sorry, your current session has expired. To continue, please open your SMS(text) message or Email and click the forms link we sent you. Many thanks.",
    };
  },
  methods: {
    ...mapMutations(["setAppBusyAnimation"]),
    closeAlert: function() {
      this.$router.push("/");
    },
  },
  mounted() {
    this.setAppBusyAnimation(false);
  },
};
</script>
<style></style>
